/**
 * SwiftID invitation status enum.
 * Matches backend SwiftIdInvitationStatusEnum.php
 */
export enum SwiftIdInvitationStatus {
  PENDING = 'Pending',
  ACCEPTED = 'Accepted',
  REJECTED = 'Rejected',
  CANCELLED = 'Cancelled',
}

/**
 * Data model for SwiftID invitation
 */
export interface SwiftIdInvitation {
  readonly id: number;
  readonly applicationId: number;
  readonly userId: number;
  readonly invitedBy: number;
  readonly status: SwiftIdInvitationStatus;
  readonly createdAt: number;
  readonly updatedAt: number;
  readonly applicantId?: number;
}
